import { Injectable } from "@angular/core";
import { EMPTY } from "rxjs";

import { RealTimeError } from "./real-time.model";
import { SignalrService } from "./signalr.service";

@Injectable({
	providedIn: "root",
})
export class NoopSignalrService extends SignalrService {
	sendMessage() {
		return Promise.reject(RealTimeError.NoSession);
	}

	subscribeToChannel() {
		return EMPTY;
	}

	connect() {
		return Promise.reject("No realtime connections on server.");
	}

	disconnect() {
		return Promise.resolve();
	}

	isConnected() {
		return false;
	}
}
